export default "__VITE_ASSET__D8t16m09__"